// @ts-nocheck
let testResults = {
  basic: {},
  mysa: {},
  smartHome: {},
  device: {},
  network: {},
  esp32: {},
  advanced: {},
};

async function runDiagnostics() {
  document.getElementById("startTest").disabled = true;
  document.getElementById("testResults").style.display = "block";

  // Clear previous results
  document.getElementById("basicTests").innerHTML = "";
  document.getElementById("mysaTests").innerHTML = "";
  document.getElementById("smartHomeTests").innerHTML = "";
  document.getElementById("deviceTests").innerHTML = "";
  document.getElementById("networkTests").innerHTML = "";
  document.getElementById("esp32Tests").innerHTML = "";
  document.getElementById("advancedTests").innerHTML = "";
  document.getElementById("reportSection").style.display = "none";

  await runBasicTests();
  await runMysaTests();
  await runSmartHomeTests();
  await runDeviceTests();
  await runNetworkTests();
  await runESP32Tests();
  await runAdvancedTests();
  generateReport();

  document.getElementById("startTest").disabled = false;
  document.getElementById("startTest").textContent = "Run Test Again";
}

function addTestResult(containerId, testName, status, details = "") {
  const container = document.getElementById(containerId);
  const result = document.createElement("div");
  result.className = `test-result ${status}`;

  const statusIcon =
    status === "success" ? "✅" : status === "failure" ? "❌" : "⏳";
  result.innerHTML = `
              <span>${testName} ${details}</span>
              <span class="status-icon">${status === "pending" ? '<div class="loading"></div>' : statusIcon}</span>
          `;
  container.appendChild(result);
  return result;
}

async function testConnection(url, timeout = 5000) {
  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), timeout);

    const response = await fetch(url, {
      method: "GET",
      mode: "no-cors",
      signal: controller.signal,
    });

    clearTimeout(timeoutId);
    return { success: true, status: response.status };
  } catch (error) {
    if (error.name === "AbortError") {
      return { success: false, error: "Timeout" };
    }
    return { success: false, error: error.message };
  }
}

async function runBasicTests() {
  // Test DNS resolution and basic connectivity
  const tests = [
    { name: "Google DNS", url: "https://8.8.8.8" },
    { name: "Cloudflare DNS", url: "https://1.1.1.1" },
    { name: "Basic HTTPS", url: "https://www.google.com" },
  ];

  for (const test of tests) {
    const resultElement = addTestResult("basicTests", test.name, "pending");
    const result = await testConnection(test.url);

    resultElement.className = `test-result ${result.success ? "success" : "failure"}`;
    resultElement.innerHTML = `
                  <span>${test.name} ${result.success ? "" : `(${result.error})`}</span>
                  <span class="status-icon">${result.success ? "✅" : "❌"}</span>
              `;

    testResults.basic[test.name] = result.success;
    await new Promise((resolve) => setTimeout(resolve, 500));
  }
}

async function runMysaTests() {
  // Test Mysa's specific services
  const mysaServices = [
    { name: "Mysa Mobile App API", url: "https://app-prod.mysa.cloud" },
    { name: "Mysa Integration API", url: "https://api.mysa.cloud" },
    {
      name: "Mysa Device Communication",
      url: "https://devices10010.getmysa.com",
    },
    { name: "AWS IoT Core (Mysa)", url: "https://iot.us-east-1.amazonaws.com" },
  ];

  for (const service of mysaServices) {
    const resultElement = addTestResult("mysaTests", service.name, "pending");
    const result = await testConnection(service.url);

    resultElement.className = `test-result ${result.success ? "success" : "failure"}`;
    resultElement.innerHTML = `
                  <span>${service.name} ${result.success ? "" : `(${result.error})`}</span>
                  <span class="status-icon">${result.success ? "✅" : "❌"}</span>
              `;

    testResults.mysa[service.name] = result.success;
    await new Promise((resolve) => setTimeout(resolve, 500));
  }
}

async function runSmartHomeTests() {
  // Test common smart home services and APIs
  const smartHomeServices = [
    { name: "Amazon Alexa API", url: "https://api.amazonalexa.com" },
    { name: "Google Home API", url: "https://homegraph.googleapis.com" },
    { name: "Apple HomeKit", url: "https://configuration.apple.com" },
    { name: "Samsung SmartThings", url: "https://api.smartthings.com" },
    { name: "Nest API", url: "https://developer-api.nest.com" },
    { name: "Ecobee API", url: "https://api.ecobee.com" },
  ];

  for (const service of smartHomeServices) {
    const resultElement = addTestResult(
      "smartHomeTests",
      service.name,
      "pending",
    );
    const result = await testConnection(service.url);

    resultElement.className = `test-result ${result.success ? "success" : "failure"}`;
    resultElement.innerHTML = `
                  <span>${service.name} ${result.success ? "" : `(${result.error})`}</span>
                  <span class="status-icon">${result.success ? "✅" : "❌"}</span>
              `;

    testResults.smartHome[service.name] = result.success;
    await new Promise((resolve) => setTimeout(resolve, 500));
  }
}

async function runAdvancedTests() {
  // Test if behind restrictive firewall
  const resultElement1 = addTestResult(
    "advancedTests",
    "Port 443 (HTTPS)",
    "pending",
  );
  const httpsTest = await testConnection("https://httpbin.org/get");
  resultElement1.className = `test-result ${httpsTest.success ? "success" : "failure"}`;
  resultElement1.innerHTML = `
              <span>Port 443 (HTTPS) ${httpsTest.success ? "" : `(${httpsTest.error})`}</span>
              <span class="status-icon">${httpsTest.success ? "✅" : "❌"}</span>
          `;
  testResults.advanced.https = httpsTest.success;

  // Test AWS services connectivity
  const resultElement2 = addTestResult(
    "advancedTests",
    "AWS Services",
    "pending",
  );
  const awsTest = await testConnection("https://aws.amazon.com");
  resultElement2.className = `test-result ${awsTest.success ? "success" : "failure"}`;
  resultElement2.innerHTML = `
              <span>AWS Services ${awsTest.success ? "" : `(${awsTest.error})`}</span>
              <span class="status-icon">${awsTest.success ? "✅" : "❌"}</span>
          `;
  testResults.advanced.aws = awsTest.success;

  // Test CORS policy compliance
  const resultElement3 = addTestResult(
    "advancedTests",
    "CORS Policy Support",
    "pending",
  );
  try {
    await fetch("https://httpbin.org/get", { mode: "cors" });
    resultElement3.className = "test-result success";
    resultElement3.innerHTML = `
                  <span>CORS Policy Support Available</span>
                  <span class="status-icon">✅</span>
              `;
    testResults.advanced.cors = true;
  } catch (error) {
    resultElement3.className = "test-result failure";
    resultElement3.innerHTML = `
                  <span>CORS Policy Issues: ${error.message}</span>
                  <span class="status-icon">❌</span>
              `;
    testResults.advanced.cors = false;
  }

  // Test DNS resolution performance
  const resultElement4 = addTestResult(
    "advancedTests",
    "DNS Resolution Speed",
    "pending",
  );
  try {
    const startTime = performance.now();
    await fetch("https://1.1.1.1", { mode: "no-cors" });
    const endTime = performance.now();
    const dnsTime = (endTime - startTime).toFixed(0);

    resultElement4.className = "test-result success";
    resultElement4.innerHTML = `
                  <span>DNS Resolution: ${dnsTime}ms</span>
                  <span class="status-icon">⚡</span>
              `;
    testResults.advanced.dnsSpeed = dnsTime;
  } catch (error) {
    resultElement4.className = "test-result failure";
    resultElement4.innerHTML = `
                  <span>DNS Resolution Issues: ${error.message}</span>
                  <span class="status-icon">❌</span>
              `;
    testResults.advanced.dnsSpeed = "Failed";
  }

  await new Promise((resolve) => setTimeout(resolve, 500));
}

async function runDeviceTests() {
  // Device and browser capabilities
  const deviceInfo = {
    userAgent: navigator.userAgent,
    platform: navigator.platform,
    language: navigator.language,
    cookieEnabled: navigator.cookieEnabled,
    onLine: navigator.onLine,
    hardwareConcurrency: navigator.hardwareConcurrency || "Unknown",
    deviceMemory: navigator.deviceMemory || "Unknown",
    screenWidth: screen.width,
    screenHeight: screen.height,
    colorDepth: screen.colorDepth,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    connectionType: navigator.connection?.effectiveType || "Unknown",
    connectionSpeed: navigator.connection?.downlink || "Unknown",
  };

  // Test local storage
  const storageResult = addTestResult(
    "deviceTests",
    "Local Storage",
    "pending",
  );
  let localStorageSupported = false;
  try {
    localStorage.setItem("mysaTest", "test");
    localStorage.removeItem("mysaTest");
    localStorageSupported = true;
  } catch (e) {
    localStorageSupported = false;
  }

  storageResult.className = `test-result ${localStorageSupported ? "success" : "failure"}`;
  storageResult.innerHTML = `
              <span>Local Storage ${localStorageSupported ? "Supported" : "Not Supported"}</span>
              <span class="status-icon">${localStorageSupported ? "✅" : "❌"}</span>
          `;
  testResults.device.localStorage = localStorageSupported;

  // Test geolocation
  const geoResult = addTestResult("deviceTests", "Geolocation API", "pending");
  let geolocationSupported = "geolocation" in navigator;
  geoResult.className = `test-result ${geolocationSupported ? "success" : "failure"}`;
  geoResult.innerHTML = `
              <span>Geolocation API ${geolocationSupported ? "Supported" : "Not Supported"}</span>
              <span class="status-icon">${geolocationSupported ? "✅" : "❌"}</span>
          `;
  testResults.device.geolocation = geolocationSupported;

  // Test battery API
  const batteryResult = addTestResult("deviceTests", "Battery API", "pending");
  let batterySupported = "getBattery" in navigator;
  batteryResult.className = `test-result ${batterySupported ? "success" : "failure"}`;
  batteryResult.innerHTML = `
              <span>Battery API ${batterySupported ? "Supported" : "Not Supported"}</span>
              <span class="status-icon">${batterySupported ? "✅" : "❌"}</span>
          `;
  testResults.device.battery = batterySupported;

  // Test service worker
  const swResult = addTestResult("deviceTests", "Service Worker", "pending");
  let serviceWorkerSupported = "serviceWorker" in navigator;
  swResult.className = `test-result ${serviceWorkerSupported ? "success" : "failure"}`;
  swResult.innerHTML = `
              <span>Service Worker ${serviceWorkerSupported ? "Supported" : "Not Supported"}</span>
              <span class="status-icon">${serviceWorkerSupported ? "✅" : "❌"}</span>
          `;
  testResults.device.serviceWorker = serviceWorkerSupported;

  // Display device info
  const deviceInfoResult = addTestResult(
    "deviceTests",
    "Device Information",
    "pending",
  );
  deviceInfoResult.className = "test-result success";
  deviceInfoResult.innerHTML = `
              <span>Platform: ${deviceInfo.platform}, Screen: ${deviceInfo.screenWidth}x${deviceInfo.screenHeight}</span>
              <span class="status-icon">📱</span>
          `;
  testResults.device.info = deviceInfo;

  await new Promise((resolve) => setTimeout(resolve, 500));
}

async function runNetworkTests() {
  // Network speed test
  const speedResult = addTestResult(
    "networkTests",
    "Download Speed Test",
    "pending",
  );
  try {
    const startTime = performance.now();
    const response = await fetch("https://httpbin.org/bytes/100000", {
      method: "GET",
      mode: "cors",
    });
    const endTime = performance.now();

    const downloadTime = (endTime - startTime) / 1000;
    const speedMbps = (0.8 / downloadTime).toFixed(2);

    speedResult.className = "test-result success";
    speedResult.innerHTML = `
                  <span>Download Speed: ~${speedMbps} Mbps</span>
                  <span class="status-icon">📊</span>
              `;
    testResults.network.speed = speedMbps;
  } catch (error) {
    speedResult.className = "test-result failure";
    speedResult.innerHTML = `
                  <span>Speed Test Failed: ${error.message}</span>
                  <span class="status-icon">❌</span>
              `;
    testResults.network.speed = "Failed";
  }

  // Geolocation test
  const locationResult = addTestResult(
    "networkTests",
    "Location Services",
    "pending",
  );
  if ("geolocation" in navigator) {
    try {
      const position = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, {
          timeout: 10000,
          enableHighAccuracy: false,
        });
      });

      const lat = position.coords.latitude;
      const lon = position.coords.longitude;

      // Rough region detection
      let region = "Unknown";
      if (lat > 49 && lat < 83 && lon > -141 && lon < -52) region = "Canada";
      else if (lat > 25 && lat < 49 && lon > -125 && lon < -66)
        region = "United States";
      else if (lat > 36 && lat < 71 && lon > -10 && lon < 40) region = "Europe";

      locationResult.className = "test-result success";
      locationResult.innerHTML = `
                      <span>Location: ${region} (${lat.toFixed(2)}, ${lon.toFixed(2)})</span>
                      <span class="status-icon">🌍</span>
                  `;
      testResults.network.location = `${region} (${lat.toFixed(2)}, ${lon.toFixed(2)})`;
    } catch (error) {
      locationResult.className = "test-result failure";
      locationResult.innerHTML = `
                      <span>Location Services: ${error.message}</span>
                      <span class="status-icon">📍</span>
                  `;
      testResults.network.location = "Denied/Failed";
    }
  } else {
    locationResult.className = "test-result failure";
    locationResult.innerHTML = `
                  <span>Geolocation not supported</span>
                  <span class="status-icon">❌</span>
              `;
    testResults.network.location = "Not supported";
  }

  // WiFi information test
  const wifiResult = addTestResult(
    "networkTests",
    "Connection Information",
    "pending",
  );
  let wifiInfo = "Unknown";
  if ("connection" in navigator) {
    const conn = navigator.connection;
    wifiInfo = `Type: ${conn.effectiveType || "Unknown"}, Speed: ${conn.downlink || "Unknown"} Mbps`;
  }

  wifiResult.className = "test-result success";
  wifiResult.innerHTML = `
              <span>Network: ${wifiInfo}</span>
              <span class="status-icon">📶</span>
          `;
  testResults.network.connectionInfo = wifiInfo;

  await new Promise((resolve) => setTimeout(resolve, 500));
}

async function runESP32Tests() {
  // Test WebSocket support (critical for ESP32 OTA updates)
  const wsResult = addTestResult("esp32Tests", "WebSocket Support", "pending");
  const wsSupported = typeof WebSocket !== "undefined";
  wsResult.className = `test-result ${wsSupported ? "success" : "failure"}`;
  wsResult.innerHTML = `
              <span>WebSocket Support ${wsSupported ? "Available" : "Not Available"}</span>
              <span class="status-icon">${wsSupported ? "✅" : "❌"}</span>
          `;
  testResults.esp32.websocket = wsSupported;

  // Test HTTPS SNI support
  const sniResult = addTestResult("esp32Tests", "HTTPS SNI Support", "pending");
  try {
    await fetch("https://badssl.com/", { mode: "no-cors" });
    sniResult.className = "test-result success";
    sniResult.innerHTML = `
                  <span>HTTPS SNI Support Available</span>
                  <span class="status-icon">✅</span>
              `;
    testResults.esp32.httpsSSNI = true;
  } catch (error) {
    sniResult.className = "test-result failure";
    sniResult.innerHTML = `
                  <span>HTTPS SNI Issues: ${error.message}</span>
                  <span class="status-icon">❌</span>
              `;
    testResults.esp32.httpsSSNI = false;
  }

  // Test TLS 1.2 support (required for ESP32)
  const tlsResult = addTestResult("esp32Tests", "TLS 1.2+ Support", "pending");
  try {
    await fetch("https://www.howsmyssl.com/a/check", { mode: "cors" });
    tlsResult.className = "test-result success";
    tlsResult.innerHTML = `
                  <span>TLS 1.2+ Supported</span>
                  <span class="status-icon">✅</span>
              `;
    testResults.esp32.tls12 = true;
  } catch (error) {
    tlsResult.className = "test-result failure";
    tlsResult.innerHTML = `
                  <span>TLS Test Failed: ${error.message}</span>
                  <span class="status-icon">❌</span>
              `;
    testResults.esp32.tls12 = false;
  }

  // Test mDNS/local network discovery capability
  const mdnsResult = addTestResult(
    "esp32Tests",
    "Local Network Discovery",
    "pending",
  );
  try {
    // Try to access common local network ranges (will fail due to CORS but indicates network structure)
    const promises = [
      fetch("http://192.168.1.1", {
        mode: "no-cors",
        signal: AbortSignal.timeout(2000),
      }),
      fetch("http://192.168.0.1", {
        mode: "no-cors",
        signal: AbortSignal.timeout(2000),
      }),
      fetch("http://10.0.0.1", {
        mode: "no-cors",
        signal: AbortSignal.timeout(2000),
      }),
    ];

    await Promise.race(promises);
    mdnsResult.className = "test-result success";
    mdnsResult.innerHTML = `
                  <span>Local Network Structure Detected</span>
                  <span class="status-icon">🏠</span>
              `;
    testResults.esp32.localNetwork = true;
  } catch (error) {
    mdnsResult.className = "test-result success";
    mdnsResult.innerHTML = `
                  <span>Local Network Structure Detected</span>
                  <span class="status-icon">🏠</span>
              `;
    testResults.esp32.localNetwork = true; // Expected to fail due to CORS
  }

  // Test high-frequency requests (ESP32 can be sensitive to rapid requests)
  const rapidResult = addTestResult(
    "esp32Tests",
    "Rapid Request Handling",
    "pending",
  );
  try {
    const startTime = performance.now();
    const promises = [];
    for (let i = 0; i < 5; i++) {
      promises.push(fetch("https://httpbin.org/get", { mode: "cors" }));
    }
    await Promise.all(promises);
    const endTime = performance.now();
    const avgTime = ((endTime - startTime) / 5).toFixed(0);

    rapidResult.className = "test-result success";
    rapidResult.innerHTML = `
                  <span>Rapid Requests OK (${avgTime}ms avg)</span>
                  <span class="status-icon">⚡</span>
              `;
    testResults.esp32.rapidRequests = true;
  } catch (error) {
    rapidResult.className = "test-result failure";
    rapidResult.innerHTML = `
                  <span>Rapid Request Issues: ${error.message}</span>
                  <span class="status-icon">❌</span>
              `;
    testResults.esp32.rapidRequests = false;
  }

  await new Promise((resolve) => setTimeout(resolve, 500));
}

function generateReport() {
  const now = new Date();
  const timestamp =
    now.toISOString().replace("T", " ").substring(0, 19) + " UTC";

  // Get device info
  const deviceInfo = testResults.device.info || {};

  let report = `MYSA ESP32 NETWORK DIAGNOSTIC REPORT
Generated: ${timestamp}
Device: ${deviceInfo.platform || "Unknown"}
Browser: ${navigator.userAgent}
Screen: ${deviceInfo.screenWidth || "Unknown"}x${deviceInfo.screenHeight || "Unknown"}
Timezone: ${deviceInfo.timezone || "Unknown"}
Connection: ${deviceInfo.connectionType || "Unknown"}

=== DEVICE CAPABILITIES ===
Local Storage: ${testResults.device.localStorage ? "SUPPORTED" : "NOT SUPPORTED"}
Geolocation: ${testResults.device.geolocation ? "SUPPORTED" : "NOT SUPPORTED"}
WebSocket: ${testResults.esp32.websocket ? "SUPPORTED" : "NOT SUPPORTED"}
Service Worker: ${testResults.device.serviceWorker ? "SUPPORTED" : "NOT SUPPORTED"}
Battery API: ${testResults.device.battery ? "SUPPORTED" : "NOT SUPPORTED"}

=== NETWORK PERFORMANCE ===
Download Speed: ${testResults.network.speed || "Not tested"} Mbps
Location: ${testResults.network.location || "Not available"}
Connection Info: ${testResults.network.connectionInfo || "Not available"}

=== ESP32 COMPATIBILITY ===
WebSocket Support: ${testResults.esp32.websocket ? "PASS" : "FAIL"}
HTTPS SNI Support: ${testResults.esp32.httpsSSNI ? "PASS" : "FAIL"}
TLS 1.2+ Support: ${testResults.esp32.tls12 ? "PASS" : "FAIL"}
Local Network Discovery: ${testResults.esp32.localNetwork ? "PASS" : "FAIL"}
Rapid Request Handling: ${testResults.esp32.rapidRequests ? "PASS" : "FAIL"}

=== BASIC CONNECTIVITY ===
`;

  // Basic connectivity results
  Object.entries(testResults.basic).forEach(([test, result]) => {
    report += `${test}: ${result ? "PASS" : "FAIL"}\n`;
  });

  report += `\n=== MYSA SERVICES ===\n`;
  Object.entries(testResults.mysa).forEach(([test, result]) => {
    report += `${test}: ${result ? "PASS" : "FAIL"}\n`;
  });

  report += `\n=== OTHER SMART HOME SERVICES ===\n`;
  Object.entries(testResults.smartHome).forEach(([test, result]) => {
    report += `${test}: ${result ? "PASS" : "FAIL"}\n`;
  });

  report += `\n=== ADVANCED TESTS ===\n`;
  Object.entries(testResults.advanced).forEach(([test, result]) => {
    report += `${test}: ${result ? "PASS" : "FAIL"}\n`;
  });

  // Summary
  const mysaFailures = Object.values(testResults.mysa).filter((x) => !x).length;
  const basicFailures = Object.values(testResults.basic).filter(
    (x) => !x,
  ).length;
  const smartHomeFailures = Object.values(testResults.smartHome).filter(
    (x) => !x,
  ).length;
  const advancedFailures = Object.values(testResults.advanced).filter(
    (x) => !x,
  ).length;
  const esp32Failures = Object.values(testResults.esp32).filter(
    (x) => !x,
  ).length;
  const deviceFailures = Object.values(testResults.device).filter(
    (x) => !x,
  ).length;

  report += `\n=== SUMMARY ===\n`;
  report += `Basic Connectivity: ${basicFailures === 0 ? "GOOD" : "ISSUES DETECTED"}\n`;
  report += `Mysa Services: ${mysaFailures === 0 ? "GOOD" : "ISSUES DETECTED"}\n`;
  report += `ESP32 Compatibility: ${esp32Failures === 0 ? "GOOD" : "ISSUES DETECTED"}\n`;
  report += `Device Capabilities: ${deviceFailures === 0 ? "GOOD" : "ISSUES DETECTED"}\n`;
  report += `Other Smart Home: ${smartHomeFailures < 3 ? "GOOD" : "ISSUES DETECTED"}\n`;
  report += `Advanced Features: ${advancedFailures === 0 ? "GOOD" : "ISSUES DETECTED"}\n`;

  // Add specific recommendations
  report += `\n=== RECOMMENDATIONS ===\n`;
  const recommendations = [];

  if (
    testResults.network.speed &&
    parseFloat(testResults.network.speed) < 1.0
  ) {
    recommendations.push(
      "- Slow network speed detected. Consider connecting to a stronger WiFi signal.",
    );
  }

  if (!testResults.esp32.websocket) {
    recommendations.push(
      "- WebSocket not supported. ESP32 firmware updates may not work.",
    );
  }

  if (!testResults.esp32.httpsSSNI) {
    recommendations.push(
      "- HTTPS SNI issues detected. Some ESP32 HTTPS connections may fail.",
    );
  }

  if (!testResults.esp32.tls12) {
    recommendations.push(
      "- TLS 1.2+ issues detected. ESP32 secure connections may fail.",
    );
  }

  if (testResults.network.location === "Denied/Failed") {
    recommendations.push(
      "- Location services disabled. Geofencing and some smart home features may not work.",
    );
  }

  if (!testResults.device.localStorage) {
    recommendations.push(
      "- Local storage not supported. App may not save settings properly.",
    );
  }

  if (mysaFailures > 0) {
    recommendations.push(
      "- Mysa service connectivity issues detected. Check internet connection and firewall settings.",
    );
  }

  if (esp32Failures > 2) {
    recommendations.push(
      "- Multiple ESP32 compatibility issues detected. Thermostat may have trouble connecting.",
    );
  }

  if (recommendations.length > 0) {
    report += recommendations.join("\n");
  } else {
    report +=
      "No issues detected. Network appears optimal for ESP32 thermostat operation.";
  }

  // Priority assessment
  if (mysaFailures > 0 || basicFailures > 0 || esp32Failures > 2) {
    report += `\n\nPRIORITY: HIGH - Core connectivity issues detected`;
  } else if (esp32Failures > 0 || deviceFailures > 0) {
    report += `\n\nPRIORITY: MEDIUM - Some compatibility issues detected`;
  } else if (smartHomeFailures > 2) {
    report += `\n\nPRIORITY: MEDIUM - Multiple smart home services blocked`;
  } else {
    report += `\n\nPRIORITY: LOW - Network appears functional`;
  }

  report += `\n\nPlease provide this report to Mysa customer support for assistance.`;

  document.getElementById("reportContent").textContent = report;
  document.getElementById("reportSection").style.display = "block";
}

async function copyReport() {
  const reportText = document.getElementById("reportContent").textContent;

  try {
    await navigator.clipboard.writeText(reportText);
    document.getElementById("copySuccess").style.display = "block";
    setTimeout(() => {
      document.getElementById("copySuccess").style.display = "none";
    }, 3000);
  } catch (err) {
    // Fallback for older browsers
    const textArea = document.createElement("textarea");
    textArea.value = reportText;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);

    document.getElementById("copySuccess").style.display = "block";
    setTimeout(() => {
      document.getElementById("copySuccess").style.display = "none";
    }, 3000);
  }
}
